import { useEffect, useRef } from 'react';
import fly from '../http';
import { set } from 'lodash';
var authErrCode = ['UNAUTHORIZED', 'TOKEN_NOT_EXIST', 'TOKEN_EXPIRED', 'TOKEN_INVALID', 'SYSTEM_ERROR'];
export default function useAuth(accessToken, props, jotaiProps) {
  var isAuthError = useRef(false);
  useEffect(function () {
    fly.interceptors.response.use(function (response) {
      var _response$data;
      if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code) !== 'SUCCESS') {
        var _response$data2;
        if (!isAuthError.current && !!window.SETTLEMENT_SDK_AUTH_CALLBACK && authErrCode.includes(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.code)) {
          // 鉴权失败的场景
          // onAuthError调用锁 - 打开，避免由于多个接口鉴权失败导致同时调用
          isAuthError.current = true;
          window.SETTLEMENT_SDK_AUTH_CALLBACK(response.data, fly);
        }
        return Promise.reject(response.data);
      } else {
        // 只将请求结果的data字段返回
        return response.data;
      }
    }, function (err) {
      //发生网络错误后会走到这里
      //return Promise.resolve("ssss")
    });
  }, []);
  useEffect(function () {
    if (!accessToken) return;
    set(fly.config, 'extra.accessToken', accessToken);
  }, [accessToken]);
}